






















import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { QRcodeLayer } from "@/model/document2/page/surface/design/layer/qrcodeLayer";

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class QRcodeVersionController extends Vue 
{
    @Prop() layer! : QRcodeLayer;

    private static readonly VERSION_AUTO_ON = "自動ON";
    private static readonly VERSION_AUTO_OFF = "自動OFF";

    private static readonly VERSION_MIN = 1;
    private static readonly VERSION_MAX = 40;

    private get version()
    {
        return this.layer.version;
    }

    private set version(version)
    {
        this.changeLayerProperty("version", Number(version), false, false);
    }

    private get versionText()
    {
        return "" + this.layer.version;
    }

    private onVersionChanged()
    {
        this.changeLayerProperty("version", this.layer.version, true, false);
    }

    private changeVersionAuto()
    {
        var newVersion = this.version == 0 ? QRcodeVersionController.VERSION_MIN : 0;
        this.changeLayerProperty("version", newVersion, true, true);
    }

    private get versionAuto()
    {
        return this.version == 0 ? QRcodeVersionController.VERSION_AUTO_ON : QRcodeVersionController.VERSION_AUTO_OFF;
    }

    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeLayerProperty", propertyName, value, isFinish, isOnce);
    }
}
